<template>
    <v-container fluid>
        <v-row class="justify-center">
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>{{$t('registrationForm')}}
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-form v-model="formValid" ref="form">
                            <v-text-field :rules="requiredRule" v-model="driver.fullname"
                                          :label="$t('fullName')"></v-text-field>
                            <!--                            <v-text-field :rules="requiredRule" v-model="driver.driver_code" label="Numer karty kierowcy"></v-text-field>-->
                            <v-select :rules="requiredRule" return-object v-model="selectedCompetition"
                                      :items="filteredCompetitions" :label="$t('selectSession')"></v-select>
                            <h3 v-if="selectedCompetition">Wybierz wyścigi
                                <small>max: {{ selectedCompetition.selection_limit }}</small></h3>
                            <v-checkbox dense :hide-details="false" :rules="checkboxRule" color="black"
                                        @change="checkboxOverflowCheck($event)" v-if="selectedCompetition"
                                        v-model="selectedTrainings" :value="training.id"
                                        v-for="training in selectedCompetition.trainings" :key="training.id"
                                        :label="`${training.name} | ${training.start_time} - ${training.end_time} | ${training.drivers.length || '0'} / ${training.seats_number}`"/>
                            <!--                            <v-text-field v-model="driver.voucher" :rules="requiredRule" v-if="selectedCompetition" label="Voucher" hint="Wprowadzenie nieprawidłowego vouchera spowoduje wyrzuceniem z treningów"></v-text-field>-->
                        </v-form>
                    </v-card-text>
                    <vue-recaptcha class="ml-4 mt-0" @verify="verifyCaptcha" ref="captcha" sitekey="6LcWNAkqAAAAAF_g8-Ijes26-nsHwZNScA9wH6ue"/>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="registerDriver" v-if="!isMobile" text :disabled="!formValid || !verified">{{$t('save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-btn fixed fab :disabled="!formValid || !verified" @click="registerDriver" v-if="isMobile" class="saveBtn" color="black" dark>
                <v-icon>mdi-content-save</v-icon>
            </v-btn>
        </v-row>
    </v-container>
</template>

<script>
import {VueRecaptcha} from "vue-recaptcha";
export default {
    name: "Index",
    props: ['competitions'],
    components: {
        VueRecaptcha
    },
    data() {
        return {
            driver: {
                fullname: '',
                driver_code: ''
            },
            selectedCompetition: '',
            selectedTrainings: [],
            overflowFlag: false,
            helpOverlay: false,
            formValid: false,
            verified: false,
            requiredRule: [
                v => !!v || "Pole jest wymagane"
            ],
        }
    },
    methods: {
        registerDriver() {
            if (!this.verified) {
                this.$inertia.visit('/');
                return;
            }

            this.$inertia.post('/driver', {
                competition: this.selectedCompetition,
                trainings: this.selectedTrainings,
                driver: this.driver
            })
        },
        verifyCaptcha(response) {
            this.verified = true;
        },
        checkboxOverflowCheck(data) {
            this.selectedTrainings.forEach(id => {
                const t = this.selectedCompetition.trainings.find(t => t.id === id);
                if (t.drivers.length === t.seats_number) this.overflowFlag = true;
                if (t.drivers.length < t.seats_number) this.overflowFlag = false
            })
        },
        showHelp() {
            this.helpOverlay = true;
        }
    },
    inject: ['getLeagueFilter'],
    computed: {
        competitionsSelect() {
            return this.competitions.map(c => {
                return {text: c.name, value: c.id, trainings: c.trainings, selection_limit: c.selection_limit, league: c.league}
            })
        },
        leagueFilter() {
            return this.getLeagueFilter();
        },
        filteredCompetitions() {
            if (this.leagueFilter) {
                return this.competitionsSelect.filter(c => c.league === this.leagueFilter);
            } else {
                return this.competitionsSelect;
            }
        },
        checkboxRule() {
            return [
                this.selectedTrainings.length > 0 || "Przynajmniej jeden trening musi być wybrany",
                this.selectedTrainings.length <= this.selectedCompetition.selection_limit || "Zmniejsz liczbę wybranych treningów",
                !this.overflowFlag || "Jeden z treningów jest pełen"
            ]
        },
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        }
    }
}
</script>

<style scoped>
    ol li {
        margin-bottom: 10px;
    }
</style>
